import {
  AppBar, Button, Container, Grid, Toolbar, Typography,
} from '@material-ui/core';

import Autorenew from '@material-ui/icons/Autorenew';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import { withStyles } from '@material-ui/styles';
import React, { Component } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { changePassword } from '../../actions';

import LoginBackButton from '../../assets/images/login-button.svg';
import headerLogo from '../../assets/images/logo-revbits.png';
import darkLogo from '../../assets/images/theme-switch-dark.svg';
import lightLogo from '../../assets/images/theme-switch-light.svg';
import dmLogo from '../../assets/images/up-login-dm-logo.png';
import lmLogo from '../../assets/images/update_portal_login.png';

import styles from '../../assets/jss/NewLoginScreenStyles';

import { ROUTE } from '../../constant';
import { CheckIfNotEmpty } from '../../helper/StringUtils';
import { AuthService, EncryptionServices, toasterInstance } from '../../services';
import { renderTextField } from '../Form/Fields';
import PasswordField from '../Form/PasswordField';

import { required } from '../Form/validate';

import LinkExpired from './LinkExpired';

const requiredPassword = required('VALIDATION.REQ_PASSWORD');
const requiredIterationCount = required('VALIDATION.REQ_ITRATION_COUNT');

// eslint-disable-next-line no-unused-vars
const onSubmit = async (values, dispatch, props) => {
};

class NewChangePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirectToReferrer: false,
    };

    this.isExactPassword = false;
    this.isStrongPassword = false;

    const urlParams = new URLSearchParams(window.location.search);
    this.token = urlParams.get('token');

    EncryptionServices.decodeJwtToken(this.token).then((decVal) => {
      this.userData = decVal;
    });
  }

  componentDidMount() {
    document.title = 'Software Update Portal - Change Password';
  }

  validatePassword = (event) => {
    this.isStrongPassword = false;
    const password = event.target.value;

    // Create an array and push all possible values that you want in password
    // Special Character, Uppercase alphabets, Lowercase alphabets, Numbers
    const matchedCase = ['[$@$!%*#?&]', '[A-Z]', '[0-9]', '[a-z]'];

    // Check the conditions
    let ctr = 0;
    for (let i = 0; i < matchedCase.length; i += 1) {
      if (new RegExp(matchedCase[i]).test(password)) {
        ctr += 1;
      }
    }
    if (password && (ctr === 3 || password.length < 12)) {
      this.isStrongPassword = true;
    }
  };

  submitSetPassword = (event) => {
    const { formValues, history } = this.props;

    const {
      newpassword,
      confirmpassword,
      iterationCount,
    } = formValues;

    if (newpassword === confirmpassword) {
      if (CheckIfNotEmpty(this.userData.email) && CheckIfNotEmpty(newpassword) && CheckIfNotEmpty(iterationCount)) {
        EncryptionServices.generateCredential(this.userData.email, newpassword, iterationCount).then(
          (credentials) => {
            const tokenData = { token: this.token };
            const passwordData = { ...tokenData, ...credentials };
            changePassword(passwordData).then((res) => {
              const data = res;
              if (data && data.data && data.data.status === 200) {
                history.push('/login');
                toasterInstance(<Trans>{data.data.message}</Trans>, 2, 'successChangePassword');
              } else if (res && res.response) {
                if (typeof (res.response.errors) === 'string') {
                  toasterInstance(<Trans>{res.response.errors}</Trans>, 4, 'failedClient');
                } else {
                  res.data.response.errors.forEach((innerData) => {
                    toasterInstance(<Trans>{innerData.msg}</Trans>, 4, 'failedClietn');
                  });
                }
              }
            });
          },
        );
      } else {
        event.target.newpassword.classList.add('warning');
        event.target.confirmpassword.classList.add('warning');
        event.target.iterationCount.classList.add('warning');
        toasterInstance(<Trans>TOASTER.SET_PASSWORD_DATA</Trans>, 4, 'blankChangePassword');
      }
    } else {
      toasterInstance(<Trans>TOASTER.SET_PASSWORD_DATA</Trans>, 4, 'blankChangePassword');
    }
  };

  comparePassword = (event) => {
    const match = event.target.value;
    this.isExactPassword = false;
    const { formValues } = this.props;
    if (formValues && match && formValues.newpassword !== match) {
      this.isExactPassword = true;
    }
  };

  render() {
    const {
      classes,
      location,
      type,
      expired,
      history,
      logo,
      changeTheme,
      handleSubmit,
      pristine,
      valid,
      submitting,
    } = this.props;

    const { from } = location.state || { from: ROUTE.ROOT };
    const { redirectToReferrer } = this.state;
    if (redirectToReferrer || AuthService.isLoggedIn()) return <Redirect to={from} />;

    if (expired && (type).trim() === 'set-request') {
      history.push('/login');
    }

    if (expired && (type).trim() === 'reset-request') {
      return <Route path={ROUTE.CHANGE_PASSWORD} component={LinkExpired} />;
    }

    return (
      <div className={classes.main}>

        <AppBar position="static" className={classes.header}>
          <Toolbar>
            <img className={classes.headerLogo} src={headerLogo} alt="header logo" />
            <Typography variant="h6" className={classes.title} />
            <Button color="inherit" onClick={changeTheme}>
              {logo ? (
                <img src={darkLogo} alt="login logo" />
              ) : (
                <img src={lightLogo} alt="login logo" />
              )}

            </Button>
          </Toolbar>
        </AppBar>

        <Container maxWidth="xl" className={classes.mainLogin}>

          <Grid container spacing={0} style={{ height: '100%' }}>

            <Grid item xs={12} sm={12} md={6} lg={6} className={classes.loginLeft}>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <div className="rightLogo">

                    {logo ? (
                      <img src={dmLogo} alt="login logo" />
                    ) : (
                      <img src={lmLogo} alt="" />
                    )}

                    <div style={{ alignSelf: 'center' }}>
                      <p>
                        Rev
                        <span>Bits</span>
                      </p>
                      <span>SOFTWARE UPDATE PORTAL</span>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} />

              </Grid>

            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} style={{ display: 'flex' }}>

              <div className={classes.loginRight}>

                <Grid container spacing={0} alignItems="flex-end" className={classes.mobileLogo}>
                  <Grid item xs={12}>
                    {logo ? (
                      <img src={dmLogo} alt="login logo" width="auto" height="120" />
                    ) : (
                      <img src={lmLogo} alt="" width="auto" height="120" />
                    )}
                  </Grid>

                  <Grid item xs={12}>

                    <h1 className={classes.mobileHeading}>Change Password</h1>

                  </Grid>
                </Grid>

                <form
                  className="loginForm"
                  name="loginForm"
                  onSubmit={handleSubmit(this.submitSetPassword)}
                  noValidate
                  autoComplete="off"
                >

                  <Grid container alignItems="flex-end" className={classes.marginBottom}>

                    <Grid item className={classes.formInput}>
                      <Field
                        validate={[requiredPassword]}
                        component={PasswordField}
                        id="newpassword"
                        name="newpassword"
                        type="password"
                        label={<Trans>LOGIN.PASS</Trans>}
                        classes={classes}
                        onChange={(e) => {
                          this.validatePassword(e);
                        }}
                      />

                    </Grid>

                    <Grid item className={classes.helpIconOnLogin}>
                      <HelpOutlineIcon />
                      <div className="loginPasswordHelpIcon">
                        <Trans>VALIDATION.PASSWORD_HELP</Trans>
                      </div>
                    </Grid>
                    {this.isStrongPassword ? (
                      <label className={classes.errorMessage}>
                        Please enter strong password of at least 12
                        characters
                      </label>
                    ) : ''}

                  </Grid>

                  <Grid container alignItems="flex-end" className={classes.marginBottom}>

                    <Grid item className={classes.formInput}>
                      <Field
                        validate={[requiredPassword]}
                        component={PasswordField}
                        id="confirmpassword"
                        name="confirmpassword"
                        type="password"
                        label={<Trans>LOGIN.CPASS</Trans>}
                        classes={classes}
                        onChange={(e) => {
                          this.comparePassword(e);
                        }}
                      />

                    </Grid>

                    {this.isExactPassword
                      ? <label className={classes.errorMessage}>Password do not match</label> : ''}

                  </Grid>

                  <Grid container alignItems="flex-end" className={classes.marginBottom}>
                    <Grid item className={classes.formInput}>
                      <Field
                        validate={[requiredIterationCount]}
                        component={renderTextField}
                        id="iterationCount"
                        name="iterationCount"
                        autoComplete="on"
                        type="text"
                        label={<Trans>LOGIN.ITC</Trans>}
                        classes={classes}
                        icon={<Autorenew />}
                      />
                    </Grid>
                  </Grid>

                  <Grid
                    container
                    justify="flex-end"
                    className={`${classes.linkCss} ${classes.registerUser} ${classes.loginUser}`}
                  >

                    <Button
                      type="submit"
                      disabled={pristine || !valid || submitting || this.isExactPassword || this.isStrongPassword}
                      className={classes.activeButton}
                    >
                      <img src={LoginBackButton} alt="" />
                      <Trans>SUBMIT</Trans>
                    </Button>

                  </Grid>

                  <Grid
                    container
                    justify="flex-end"
                    className={`${classes.linkCss} ${classes.forgotPassword}`}
                  >

                    <Grid item xs={12}>
                      <img src={headerLogo} className={classes.footerLogo} alt="header logo" />

                    </Grid>

                  </Grid>

                </form>
              </div>
            </Grid>

          </Grid>

        </Container>

        <AppBar className={classes.footer} position="fixed" color="primary">
          <Toolbar>
            <Typography variant="subtitle2" className={classes.title} style={{ textAlign: 'center' }}>
              ©
              {' '}
              {new Date().getFullYear()}
              {' '}
              RevBits Software Update Portal. All Rights Reserved.
            </Typography>
          </Toolbar>
        </AppBar>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  formValues: getFormValues('login')(state),
});

const stylesheets = reduxForm({
  form: 'login',
  onSubmit,
})(withStyles(styles, { withTheme: true })(NewChangePassword));
export default withTranslation()(
  connect(
    mapStateToProps,
  )(stylesheets),
);
